export default __webpack_public_path__ + "static/media/questionPaper.0bd5e2eb.jpg";